export default __webpack_public_path__ + "static/media/terry.d7fd11e5.jpg";